import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 9l-3 3l3 3","key":"svg-0"}],["path",{"d":"M14 9l3 3l-3 3","key":"svg-1"}]]

const IconDirectionHorizontal = createReactComponent('outline', 'direction-horizontal', 'DirectionHorizontal', __iconNode);

export default IconDirectionHorizontal;